/**
 * 部门
 */

 import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectDepartmentById = (Id) => {
  return get('/api/app/Department?CurrentId=' + Id);
}

/**
 * 根据类别Id获取到它的上级分类及上上级分类
 * @param {*} Id
 * @returns
 */
export const GetDepartmentListById = (Id) => {
  return get('/api/app/Department/'+Id+'/DepartmentListById');
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddDepartment = (data) => {
  return post('/api/app/Department', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyDepartment = (data) => {
  return put('/api/app/Department', data, {});
}

/**
 * 分页获取课程分类
 * @param {*} data
 * @returns
 */
export const GetDataDepartmentList = (data) => {
  return post('/api/app/Department/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteDepartment = (id) => {
  return del('/api/app/Department/' + id, {}, {});
}